const resources = {
    allTopics: 'Tous les sujets'
};

export default function getResource(label) {
    return resources[label];
}
